import { render } from "./ArticleStages.vue?vue&type=template&id=51de56b5&scoped=true"
import script from "./ArticleStages.vue?vue&type=script&lang=js"
export * from "./ArticleStages.vue?vue&type=script&lang=js"

import "./ArticleStages.vue?vue&type=style&index=0&id=51de56b5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51de56b5"]])

export default __exports__